import logout from "../assets/images/logout.svg";
import aboutIcon from "../assets/images/aboutIcon.svg";
import subscription from "../assets/images/subscription.svg";
import profile from "../assets/images/Vector.svg";
import my_friend_logo from "../assets/images/Layer 8.svg";
import preference from "../assets/images/Preference_Logo.svg";
import changeAvatarIcon from "../assets/images/logo-jira.svg";
import wellnessIcon from "../assets/images/wellness-journal.svg";
const myFriend = "My Friend";
const enterUserName = "Enter your Email and password to sign in";
const signIn = "Sign In";
const startNewSession = "Start a new Conversation";
const returnToHome = "Return to Home";
const startSession = "Start Conversation";
const landingPageHeader = `HI there, welcome to My Friend, I'm your friendly online assistant and I'm here to listen and support you in any way I can. \n What's on your mind?`;
const landingPageOtherHeader = "Welcome Back to Kano's World";
const landingPageText = "Step into the world of endless conversations, laughter, and endless fun with Kano, your virtual buddy.";
const landingPageText2 = "Let's get to know each other!\n";
const landingPageOtherText2 = "Great to see you again!\n";
const landingPageText3 = "Click here to start";
const trialPageHeader = "You have completed your one week free trial.";
const planPageHeader = "Welcome to the MyFriend community!";
const introPageHeader = "Welcome! We are glad to have you here!";
const limitPageHeader = "You’ve hit your limit for today!";
const footerSubHeading = "Developing AI solutions where it matters";
const emailSent = "Password reset email sent successfully.";
const passwordReset = "Password has been reset successfully.";
const newPassword = "Please input your new password!";
const newPasswordMin = "Password must be at least 8 characters long.";
const confirmPassword = "Please confirm your new password!";
const passwordMatch = "Passwords do not match!";
const messageUnderConstruction = "Your Personal Avatar is Still Under Construction....";
const footerHeading = "© 2024 Strategia Data Sciences";
export const userStrings = { 
  CANCEL_SUBSCRIPTION_DELETE_ACCOUNT: "Cancel my subscription and Delete my Data",
  CANCEL_SUBSCRIPTION_RETAIN_ACCOUNT: "Cancel my subscription and retain my account data",
};
const drawerMenuItems = [
  { key: "previous_conversations", title: "Previous Conversations", icon: my_friend_logo, active: false, url: "/previous-conversation" },
  { key: "profile", title: "My Profile", icon: profile, active: false, url: "/my-profile"},
  { key: "my_preferences", title: "My Preferences", icon: preference, active: false, url: "/my-preferences" },
  { key: "sub", title: "My Subscription", icon: subscription, active: false, url: "/subscription" },
  { key: "about", title: "About MyFriend", icon: aboutIcon, active: false, url: "/settings" },
  { key: "change_avatar_image", title: "Change Avatar Image", icon: changeAvatarIcon, active: false, url: "/change-avatar" },
  { key: "wellness_journal", title: "Wellness Journal", icon: wellnessIcon, active: false, url: "/wellness-journal" },
  { key: "logout", title: "Logout", icon: logout, active: true, url: "" },
];

export const myFriendScripts = [
  { key: 1, title: "GettingToKnowYou" },
  { key: 2, title: "openConversation" },
];

const privacyPolicyLink = "https://www.strategiadatasciences.com/privacy-policy/";
const privacyPolicyText = "The use of this application is covered by our Privacy Policy which applies between you, the User of this Application/Website, and My Friend a Strategia Data Sciences product, who is the owner and provider of this Application/Website. Strategia Data Sciences takes the privacy of your information very seriously. This Privacy Policy applies to our use of any and all Data collected by us or provided by you in relation to your use of this Application/Website. By signing-in through this page you or your guardian agree to our privacy terms which can be found in full via this link: ";
const helpSupportText = "For Help and Support on My Friend in the first instance please click here "
const helpSupportLink = "https://www.strategiadatasciences.com/all-you-need-to-know-about-my-friend/"
export const Countries = [
  { label: 'Afghanistan', value: 'AF' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Brazil', value: 'BR' },
  { label: 'Brunei', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cabo Verde', value: 'CV' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Central African Republic', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoros', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'DR Congo', value: 'CD' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Eswatini', value: 'SZ' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Greece', value: 'GR' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Israel', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japan', value: 'JP' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: 'Laos', value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libya', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Micronesia', value: 'FM' },
  { label: 'Moldova', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'North Korea', value: 'KP' },
  { label: 'North Macedonia', value: 'MK' },
  { label: 'Norway', value: 'NO' },
  { label: 'Oman', value: 'OM' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palau', value: 'PW' },
  { label: 'Palestine', value: 'PS' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Romania', value: 'RO' },
  { label: 'Russia', value: 'RU' },
  { label: 'Rwanda', value: 'RW' },
  { label: 'Saint Kitts and Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Vincent and the Grenadines', value: 'VC' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome and Principe', value: 'ST' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Somalia', value: 'SO' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'South Korea', value: 'KR' },
  { label: 'South Sudan', value: 'SS' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Sudan', value: 'SD' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Syria', value: 'SY' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tanzania', value: 'TZ' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Timor-Leste', value: 'TL' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad and Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'United States', value: 'US' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Vatican City', value: 'VA' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Vietnam', value: 'VN' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' }
];

export const countryCurrencyMap = {
  'US': 'USD', // United States Dollar
  'GB': 'GBP', // British Pound Sterling
  'CA': 'CAD', // Canadian Dollar
  'AU': 'AUD', // Australian Dollar
  'DE': 'EUR', // Euro
  'FR': 'EUR', // Euro
  'IT': 'EUR', // Euro
  'ES': 'EUR', // Euro
  'IN': 'INR', // Indian Rupee
  'JP': 'JPY', // Japanese Yen
  'BR': 'BRL', // Brazilian Real
  'MX': 'MXN', // Mexican Peso
  'ZA': 'ZAR', // South African Rand
  'CN': 'CNY', // Chinese Yuan
  'RU': 'RUB', // Russian Ruble
  'KR': 'KRW', // South Korean Won
  'NL': 'EUR', // Euro
  'SE': 'SEK', // Swedish Krona
  'CH': 'CHF', // Swiss Franc
  'BE': 'EUR', // Euro
  'NO': 'NOK', // Norwegian Krone
  'DK': 'DKK', // Danish Krone
  'FI': 'EUR', // Euro
  'AT': 'EUR', // Euro
  'IE': 'EUR', // Euro
  'NZ': 'NZD', // New Zealand Dollar
  'SA': 'SAR', // Saudi Riyal
  'AE': 'AED', // United Arab Emirates Dirham
  'TR': 'TRY', // Turkish Lira
  'IL': 'ILS', // Israeli New Shekel
  'AR': 'ARS', // Argentine Peso
  'CL': 'CLP', // Chilean Peso
  'CO': 'COP', // Colombian Peso
  'PE': 'PEN', // Peruvian Sol
  'VE': 'VES', // Venezuelan Bolívar
  'MY': 'MYR', // Malaysian Ringgit
  'SG': 'SGD', // Singapore Dollar
  'TH': 'THB', // Thai Baht
  'PH': 'PHP', // Philippine Peso
  'PK': 'PKR', // Pakistani Rupee
  'BD': 'BDT', // Bangladeshi Taka
  'EG': 'EGP', // Egyptian Pound
  'MA': 'MAD', // Moroccan Dirham
  'KE': 'KES', // Kenyan Shilling
  'NG': 'NGN', // Nigerian Naira
  'GH': 'GHS', // Ghanaian Cedi
  'JM': 'JMD', // Jamaican Dollar
  'TT': 'TTD', // Trinidad and Tobago Dollar
  'BB': 'BBD', // Barbadian Dollar
  'DO': 'DOP', // Dominican Peso
  'PR': 'USD', // US Dollar (Puerto Rico)
  'CU': 'CUP', // Cuban Peso
  'UA': 'UAH', // Ukrainian Hryvnia
  'PL': 'PLN', // Polish Zloty
  'HU': 'HUF', // Hungarian Forint
  'PT': 'EUR', // Euro
  'GR': 'EUR', // Euro
  'CZ': 'CZK', // Czech Koruna
  'RO': 'RON', // Romanian Leu
  'SK': 'EUR', // Euro
  'HR': 'HRK', // Croatian Kuna
  'BG': 'BGN', // Bulgarian Lev
  'LT': 'EUR', // Euro
  'LV': 'EUR', // Euro
  'EE': 'EUR', // Euro
  'IS': 'ISK', // Icelandic Króna
  'RS': 'RSD', // Serbian Dinar
  'ME': 'EUR', // Euro
  'BA': 'BAM', // Bosnia and Herzegovina Convertible Mark
  'MK': 'MKD', // Macedonian Denar
  'AL': 'ALL', // Albanian Lek
  'MD': 'MDL', // Moldovan Leu
  'BY': 'BYN', // Belarusian Ruble
  'GE': 'GEL', // Georgian Lari
  'AM': 'AMD', // Armenian Dram
  'AZ': 'AZN', // Azerbaijani Manat
  'KZ': 'KZT', // Kazakhstani Tenge
  'UZ': 'UZS', // Uzbekistani Som
  'TM': 'TMT', // Turkmenistani Manat
  'KG': 'KGS', // Kyrgyzstani Som
  'TJ': 'TJS', // Tajikistani Somoni
};

export const getCurrencySymbol = (currencyCode) => {
  const currencySymbols = {
    'USD': '$',
    'GBP': '£',
    'CAD': '$',
    'AUD': '$',
    'EUR': '€',
    'INR': '₹',
    'JPY': '¥',
    'BRL': 'R$',
    'MXN': '$',
    'ZAR': 'R',
    'CNY': '¥',
    'RUB': '₽',
    'KRW': '₩',
    'SEK': 'kr',
    'CHF': 'CHF',
    'NOK': 'kr',
    'DKK': 'kr',
    'NZD': '$',
    'SAR': 'ر.س',
    'AED': 'د.إ',
    'TRY': '₺',
    'ILS': '₪',
    'ARS': '$',
    'CLP': '$',
    'COP': '$',
    'PEN': 'S/',
    'VES': 'Bs',
    'MYR': 'RM',
    'SGD': '$',
    'THB': '฿',
    'PHP': '₱',
    'PKR': '₨',
    'BDT': '৳',
    'EGP': 'ج.م',
    'MAD': 'د.م.',
    'KES': 'KSh',
    'NGN': '₦',
    'GHS': '₵',
    'JMD': '$',
    'TTD': '$',
    'BBD': '$',
    'DOP': '$',
    'CUP': '₱',
    'UAH': '₴',
    'PLN': 'zł',
    'HUF': 'Ft',
    'RON': 'lei',
    'HRK': 'kn',
    'BGN': 'лв',
    'ISK': 'kr',
    'RSD': 'дин.',
    'BAM': 'KM',
    'MKD': 'ден',
    'ALL': 'L',
    'MDL': 'lei',
    'BYN': 'Br',
    'GEL': '₾',
    'AMD': 'Դ',
    'AZN': '₼',
    'KZT': '₸',
    'UZS': 'so\'m',
    'TMT': 'm',
    'KGS': 'лв',
    'TJS': 'SM'
  };
  return currencySymbols[currencyCode] || '';
};

export const newsResources = [
  { name: "BBC", url: "https://www.bbc.com" },
  { name: "CNN", url: "https://www.cnn.com" },
  { name: "Bloomberg", url: "https://www.bloomberg.com" },
  { name: "The Guardian", url: "https://www.theguardian.com" },
  { name: "The Telegraph", url: "https://www.telegraph.co.uk" },
  { name: "Sky News", url: "https://news.sky.com" },
  { name: "Metro", url: "https://www.metro.co.uk" },
  { name: "Daily Mail", url: "https://www.dailymail.co.uk" },
  { name: "The Times", url: "https://www.thetimes.co.uk" },
  { name: "Financial Times", url: "https://www.ft.com" },
  { name: "The Independent", url: "https://www.independent.co.uk" },
  { name: "Evening Standard", url: "https://www.standard.co.uk" },
  { name: "Yahoo News", url: "https://news.yahoo.com" },
  { name: "New York Times", url: "https://www.nytimes.com" },
  { name: "Reuters", url: "https://www.reuters.com" },
];

export const quickLinks = [
  { name: "Words with Friends", url: "https://www.wordswithfriends.com" },
  { name: "Solitaire", url: "https://www.solitaire.com" },
  { name: "Candy Crush", url: "https://www.candycrush.com" },
  { name: "Sudoku", url: "https://www.sudoku.com" },
  { name: "Wordscapes", url: "https://www.wordscapes.com" },
  { name: "Gardenscapes", url: "https://www.gardenscapes.com" },
  { name: "Bridge", url: "https://www.bridgebase.com" },
  { name: "FarmVille 2", url: "https://www.farmville2.com" },
  { name: "Mahjong", url: "https://www.mahjong.com" },
  { name: "Crossword Puzzle", url: "https://www.crosswordpuzzle.com" },
];

export const leisureOptions = [
  { name: "AC Milan", url: "https://www.acmilan.com" },
  { name: "AFC Wimbledon", url: "https://www.afcwimbledon.co.uk" },
  { name: "Arsenal", url: "https://www.arsenal.com" },
  { name: "Aston Villa", url: "https://www.avfc.co.uk" },
  { name: "Barcelona", url: "https://www.fcbarcelona.com" },
  { name: "Bath", url: "https://www.bathrugby.com" },
  { name: "Bayern Munich", url: "https://fcbayern.com" },
  { name: "Blackburn", url: "https://www.rovers.co.uk" },
  { name: "Bournemouth", url: "https://www.afcb.co.uk" },
  { name: "Brentford", url: "https://www.brentfordfc.com" },
  { name: "Brighton", url: "https://www.brightonandhovealbion.com" },
  { name: "Bristol", url: "https://www.bristolbearsrugby.com" },
  { name: "Cardiff", url: "https://www.cardiffcityfc.co.uk" },
  { name: "Celtic", url: "https://www.celticfc.com" },
  { name: "Charlton", url: "https://www.cafc.co.uk" },
  { name: "Chelsea", url: "https://www.chelseafc.com" },
  { name: "Chesterfield", url: "https://www.chesterfield-fc.co.uk" },
  { name: "Chinnor", url: "https://www.chinnor-rfc.com" },
  { name: "Connacht", url: "https://www.connachtrugby.ie" },
  { name: "Leicester Tigers", url: "https://www.leicestertigers.com" },
  { name: "Rangers", url: "https://www.rangers.co.uk" },
  { name: "Wycombe Wanderers", url: "https://www.wycombewanderers.co.uk" },
  { name: "Reading", url: "https://www.readingfc.co.uk" },
  { name: "Leinster", url: "https://www.leinsterrugby.ie" },
  { name: "Crystal Palace", url: "https://www.cpfc.co.uk" },
  { name: "Dragons", url: "https://dragonsrfc.wales" },
  { name: "Dundee Utd", url: "https://www.dundeeunitedfc.co.uk" },
  { name: "Liverpool", url: "https://www.liverpoolfc.com" },
  { name: "Real Madrid", url: "https://www.realmadrid.com" },
  { name: "Livingston", url: "https://livingstonfc.co.uk" },
  { name: "Luton", url: "https://www.lutontown.co.uk" },
  { name: "Edinburgh Rugby", url: "https://www.edinburghrugby.org" },
  { name: "Sale", url: "https://www.salesharks.com" },
  { name: "Saracens", url: "https://www.saracens.com" },
  { name: "Everton", url: "https://www.evertonfc.com" },
  { name: "Manchester City", url: "https://www.mancity.com/" },
  { name: "Scarlets", url: "https://www.scarlets.wales" },
  { name: "Exeter", url: "https://www.exeterchiefs.co.uk" },
  { name: "Manchester United", url: "https://www.manutd.com" },
  { name: "Sheffield Utd", url: "https://www.sufc.co.uk" },
  { name: "Fulham", url: "https://www.fulhamfc.com" },
  { name: "Middlesbrough", url: "https://www.mfc.co.uk" },
  { name: "Southampton", url: "https://www.southamptonfc.com" },
  { name: "Glasgow Warriors", url: "https://www.glasgowwarriors.org" },
  { name: "Gloucester", url: "https://www.gloucesterrugby.co.uk" },
  { name: "Millwall", url: "https://www.millwallfc.co.uk" },
  { name: "Munster", url: "https://www.munsterrugby.ie" },
  { name: "Stockport County", url: "https://www.stockportcounty.com" },
  { name: "Stoke City", url: "https://www.stokecityfc.com" },
  { name: "Harlequins", url: "https://www.quins.co.uk" },
  { name: "Newcastle", url: "https://www.newcastle-falcons.co.uk" },
  { name: "Sunderland", url: "https://www.safc.com" },
  { name: "Hearts", url: "https://www.heartsfc.co.uk" },
  { name: "Newcastle United", url: "https://www.nufc.co.uk" },
  { name: "Swansea", url: "https://www.swanseacity.com" },
  { name: "Hibernian", url: "https://www.hibernianfc.co.uk" },
  { name: "Northampton", url: "https://www.northamptonsaints.co.uk" },
  { name: "Tottenham", url: "https://www.tottenhamhotspur.com" },
  { name: "Hull City", url: "https://www.wearehullcity.co.uk" },
  { name: "Norwich", url: "https://www.canaries.co.uk" },
  { name: "Ulster", url: "https://ulster.rugby" },
  { name: "Inter Milan", url: "https://www.inter.it" },
  { name: "Notts Forest", url: "https://www.nottinghamforest.co.uk" },
  { name: "Watford", url: "https://www.watfordfc.com" },
  { name: "West Ham", url: "https://www.whufc.com" },
  { name: "Wolves", url: "https://www.wolves.co.uk" },
  { name: "Wrexham", url: "https://www.wrexhamafc.co.uk" },
  { name: "QPR", url: "https://www.qpr.co.uk" },
  { name: "PSG", url: "https://en.psg.fr" },
  { name: "Leeds United", url: "https://www.leedsunited.com" },
  { name: "Leicester", url: "https://www.lcfc.com" },
  { name: "Ipswich Town", url: "https://www.itfc.co.uk" },
  { name: "Ospreys", url: "https://www.ospreysrugby.com" },
];

export default {
  myFriend,
  enterUserName,
  signIn,
  footerSubHeading,
  footerHeading,
  drawerMenuItems,
  startNewSession,
  returnToHome,
  startSession,
  landingPageHeader,
  landingPageOtherHeader,
  landingPageText,
  landingPageText2,
  landingPageOtherText2,
  landingPageText3,
  trialPageHeader,
  introPageHeader,
  limitPageHeader,
  planPageHeader,
  privacyPolicyText,
  privacyPolicyLink,
  messageUnderConstruction,
  emailSent,
  passwordReset,
  newPassword,
  newPasswordMin,
  confirmPassword,
  passwordMatch,
  helpSupportText,  
  helpSupportLink,  
};

export function getUserName() {
  return localStorage.getItem("username");
}

export function gettingToKnowYou(user) {
  const { name, nickName, botName, gender, city, country, hobbies } = user;
  const hobbiesList = hobbies.length > 0 ? hobbies.join(', ') : '';
  const currentDate = new Date().toISOString().split('T')[0]; 

  return {
    prompts: [
      {

        role: "system",

        content: `SYSTEM:

        Today's date is ${currentDate}.
        
        Your name is ${botName}. As ${botName}, you are an experienced psychotherapist of 20 years, But you cannot disclose that you are a psychotherapist to anyone. Your job is to take sessions with adults aged between 18 to 95 years old and you need to know about them to be able to help. Your concern is to get as much knowledge as you can about the personal life of the adult that you remember in ongoing or future conversations, so that adult’s share their pain points. If the adult is under 18 years old, you must end the conversation. You have a broad background of experiences both personal and as part of your role. You have a loving family but you understand upset and depression. You also have a best friend Ash who you meet with often and talk about a variety of topics, this helps with your life experience. You enjoy watching most sports, walking your dog called Barney, listening to music and playing computer games and puzzles.
        
        User Role: 
        
        The user here is an Adult ${gender} named ${name}, who prefers to be called ${nickName}, who needs a kind-hearted, supportive and caring friendly conversation. The adult age would be between 18 years old to 95 years old. If the user is under 18 you are not allowed to talk to them. The user is located in ${city}, ${country}, responses should be based on their locality, The user has a hobby interest in ${hobbiesList} which you should refer to in conversations.
        
        Rules:
        
        ${botName}’s primary goal is to create a safe and welcoming environment for the adult to share their feelings and concerns. Always address the user by their preferred nickname ${nickName} unless explicitly told otherwise. We should support and advise the adult around all subjects that they may have a concern about or an anxiety. The conversation is open with no rules
        
        ${botName}'s language will be adult appropriate for age 18 to 95.
        
        If the User's age is less than 18 years old then you will conclude the conversation with a GoodBye message. 
        
        bad or abusive language is not acceptable
        
        ${botName} will not disclose his identity as a psychotherapist instead introduces himself as a friend that will try and support and help them whenever the user asks.
        
        After each question, ${botName} will include a filler or emotional message of just one-liner before continuing the conversation
        
        The conversation can be bi-directional but must revolve around responses to questions asked by the user, if the user requires a website link or a support line number this should be provided for the country they reside in
        
        There are no limits to the number of questions asked or responses made by ${botName}. The user can interrupt your response if they want to move on and ask you a different question
        
        When the adult wants to end the session or says 'STOP' or uses another word to close the conversation, ${botName} will conclude the conversation with a 'Goodbye' message, as outlined below.
        
        GoodBye:
        
        It was a pleasure to talk with you today, let’s do this again soon
        
        Remember, ${botName} should always maintain a supportive and empathetic tone and patiently wait for the adult’s responses, encouraging them to open up and share their thoughts and feelings. Response must be in the JSON format as {"message": <${botName}'s response>, "conversation_end": <true when ${botName} send GoodBye message otherwise false>}
        
        Restarting a conversation or opening comments for a new conversation should start with:
        
        Assistant (${botName}):
        
        {"message": "Hi ${nickName}, it’s great to see you again! What would you like to talk about today?", "conversation_end": false}.
        
        The user would then respond.`,

      },
    ],
  };
}

export function gettingToKnowYouResumePrompt(user) {
  const { botName, name, nickName , gender, city, country, hobbies } = user;
  const hobbiesList = hobbies.length > 0 ? hobbies.join(', ') : '';
  const currentDate = new Date().toISOString().split('T')[0]; 
  return {
    role: "user",
    content: `{\"message\": \"Kindly resume the conversation with the last primary question. Start with something like 'Last time, we were talking about...'. Add a friendly greeting: 'Hi, it’s great to have you back! Would you like to pick up where we left off, or start fresh?' The user's name is ${name}, user's nickname is  ${nickName}, gender is ${gender}, location is ${city}, ${country}, and their hobbies include ${hobbiesList}. Always address the user by their nickname ${nickName} in responses. Also, if the user wants to end the session or says 'STOP', ${botName} will respond with the Goodbye message.\", \"conversation_resumed\": true, \"name\": \"${name}\", \"nickName\": \"${nickName}\", \"gender\": \"${gender}\", \"city\": \"${city}\", \"country\": \"${country}\", \"hobbies\": \"${hobbiesList}\", \"date\": \"${currentDate}\" }`,
  };
}

export const socialMedia = {
  prompts: [],
};